import React from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { IoIosWarning } from 'react-icons/io';
import {
  useGetOffer,
  useGetOffers,
  useUpdateOfferStatus
} from 'legacy/events/hooks';
import { showError } from 'legacy/common/utils/toast';
import { ErrorResponse } from 'api/types/errors';

type EditPromoterStatusModalProps = {
  eventId: string;
  offerId: string;
  isActive: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  onError?: (error: ErrorResponse) => void;
};

const EditPromoterStatusModal: React.FC<EditPromoterStatusModalProps> = ({
  eventId,
  offerId,
  isActive,
  onClose,
  onSuccess,
  onError
}) => {
  const { t } = useTranslation(['events']);
  const updateOfferStatus = useUpdateOfferStatus();
  const { refetch } = useGetOffers(eventId, { enabled: false });
  const { refetch: refetchOffer } = useGetOffer(offerId, {
    enabled: false
  });
  const title = isActive ? t('settings.promoterOffers.modals.editPromoterStatus.pausePromoterTitle') : t('settings.promoterOffers.modals.editPromoterStatus.resumePromoterTitle');

  const description = isActive
    ? t('settings.promoterOffers.modals.editPromoterStatus.resumeDescription')
    : t('settings.promoterOffers.modals.editPromoterStatus.pauseDescription');

  const buttonText = isActive ? t('settings.promoterOffers.modals.editPromoterStatus.pausePromoter') : t('settings.promoterOffers.modals.editPromoterStatus.resumePromoter');

  const handleUpdateOfferStatus = () => {
    updateOfferStatus.mutate(
      {
        offerId,
        isActive: !isActive
      },
      {
        onSuccess: () => {
          onSuccess();
          refetch();
          refetchOffer();
        },
        onError: (error) => {
          onError?.(error);
          showError({
            title: t('settings.promoterOffers.modals.editPromoterStatus.errorUpdatingStatus'),
            message: error?.message || t('settings.promoterOffers.promoterCard.anErrorOccurred')
          });
        }
      }
    );
  };
  return (
    <Modal
      visible
      autoHeight
      onClose={onClose}
      type={ModalType.SMALL}
      title={title}
      icon={<IoIosWarning size={20} color="#8B661E" />}
    >
      <div className="flex flex-col mx-4">
        <div className="flex flex-col gap-2 mt-6 text-sm font-normal text-[#575757]">
          {description}
        </div>
        <div className="flex flex-row items-center justify-center gap-2 mt-6">
          <Button type={ButtonType.Inverted} onClick={onClose}>
            {t('settings.promoterOffers.modals.editPromoterStatus.cancel')}
          </Button>
          <Button type={ButtonType.Primary} onClick={handleUpdateOfferStatus}>
            {buttonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EditPromoterStatusModal;
